import { TimelineMax, Power0, Power1, Sine } from 'gsap'

export default {
  data () {
    return {
      tlBDHead: new TimelineMax(),
      tlBDEyes: new TimelineMax({repeat: -1, repeatDelay: 3.7}),

      bearGrp: 1,
      eyesDelay: 2,
      headDelay: 0,
      smileOrigin: ''
    }
  },

  mounted () {
    const head = this.$el.querySelector('.head')
    const ears = this.$el.querySelectorAll('.ear')
    const eyes = this.$el.querySelectorAll('.eyes')
    const brows = this.$el.querySelectorAll('.brow')
    const mouth = this.$el.querySelector('.spath')
    const headProps = (this.bearGrp === 1)
      ? { rotationZ: 5, xPercent: 6, yPercent: -5 }
      : { rotationZ: -7, xPercent: 4, yPercent: 0 }
    const earsProps = (this.bearGrp === 1) ? { rotation: -4 } : { rotation: 4 }
    const eyesProps = (this.bearGrp === 1) ? { scaleY: 0 } : { scaleX: 0 }

    this.tlBDHead
      .delay(this.headDelay)
      .from(ears, 2, {...earsProps, ease: Power0.easeNone, repeat: -1, yoyo: true}, 0.2)
      .from(head, 2, {...headProps, z: 0.01, force3D: true, ease: Power1.easeInOut, repeat: -1, yoyo: true, repeatDelay: 0.7})

    this.tlBDEyes
      .delay(this.eyesDelay)
      .to(eyes, 0.5, { ...eyesProps, transformOrigin: '50% 50%', ease: Power0.easeNone, yoyo: true, repeat: 1 })
      .fromTo(brows, 0.8, {y: 0}, {y: -2, ease: Sine.easeInOut, yoyo: true, repeat: 1, repeatDelay: 0.2}, 0.2)
      .to(mouth, 1, { scaleX: 1.2, svgOrigin: this.smileOrigin, ease: Sine.easeInOut, yoyo: true, repeat: 1, repeatDelay: 0.1 }, 0)
  },

  beforeDestroy () {
    this.tlBDHead.kill()
    this.tlBDEyes.kill()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/timelines/bearDonor.js